import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

export interface Resolution {
  id: number
  code: string
  name: string
  description: string
  isDefault: boolean
}

export const useResolutionData = (productId: number) => {
  const [resolutions, setResolutions] = useState<Resolution[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    setIsLoading(true)

    const standardResolution: Resolution = {
      id: 0,
      code: 'standard',
      name: t('Standard'),
      description: t('Standard'),
      isDefault: true,
    }
    const highResolution: Resolution = {
      id: 1,
      code: 'high',
      name: t('High'),
      description: t('High'),
      isDefault: false,
    }
    const customResolution: Resolution = {
      id: 1,
      code: 'custom',
      name: t('Custom'),
      description: t('Custom'),
      isDefault: false,
    }

    resolutions.push(standardResolution, highResolution, customResolution)
    setResolutions(resolutions)
    setIsLoading(false)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId])

  return { resolutions, isLoading }
}
